import React, { useState } from "react";
import { showSwal } from "../../../../common/alert";
import ModalPopup from "../../../../components/newcomponents/ModalPopup";
import instructionsIcon from "../../../../assets/images/newimages/recording-instructions-icon.svg";
import texts from "../../../../helper/texts";
import InstructionsComp from "../instructionsComp/instructionsComp";

function DenyPermissionComp(props) {
   const { closeModal = () => {} } = props;
   const [showInstructions, setShowInstructions] = useState(false);
   return (
      <div>
         {showInstructions ? (
            <InstructionsComp closeModal={closeModal} />
         ) : (
            <div className="w-1xl-med h-2xl-normal bg-white flex-center flex-column" style={{ borderRadius: "5px" }}>
               <div className="text-xlarge text-primary2 text-bold">{texts.permissionTitle}</div>
               <div className="flex-center my-5">
                  <div className="text-bold-500 text-medium text-black4">{texts.permissionSubtitle}</div>
                  <div className="ml-3 pointer" onClick={() => setShowInstructions(true)}>
                     <img src={instructionsIcon} alt="info-icon" />
                  </div>
               </div>
               <div>
                  <button className="btn-default text-small h-xsmall w-small round-border-s" onClick={closeModal}>
                     {"OK"}
                  </button>
               </div>
            </div>
         )}
      </div>
   );
}

export default DenyPermissionComp;
